import React from "react";

/**
 * Plus icon for manual-add submit (borderless grey plus, lightens on hover).
 *
 * @example
 * <ActionItemAddPlusIcon />
 * // 12×12 SVG plus inheriting currentColor from .action-item-add-plus-btn.
 */
const ActionItemAddPlusIcon = () => (
  <svg
    className="action-item-add-plus-icon"
    width="12"
    height="12"
    viewBox="0 0 14 14"
    fill="none"
    aria-hidden="true"
  >
    <path d="M7 2.5v9M2.5 7h9" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
  </svg>
);

export default ActionItemAddPlusIcon;
